import { TextInput } from '@highimpact/dashboard-ui';
import SaveIcon from '@mui/icons-material/Save';
import { Box, Button, Stack } from '@mui/material';
import { useState } from 'react';
import { PlotFormProps } from '../../../../forms/InitiWidgetFormHandler';
import {
  getName,
  getTextValue,
  isValid,
  setName,
  setTextValue,
} from '../../../../state/dashboard-element-operations';

function ResourceWidgetInitiatorForm({
  config,
  onSubmit,
  onChange,
}: PlotFormProps) {
  const [submitCount, setSubmitCount] = useState(0);
  const [isSending, setIsSending] = useState(false);
  const [validation, setValidation] = useState(isValid(config));

  const handleNameChange = (value: string) => {
    const name = value;
    const newConfig = setName(name, config);
    setValidation(isValid(newConfig));
    onChange(newConfig);
  };

  const handleDefaultValueChange = (value: string) => {
    const name = value;
    const newConfig = setTextValue(name, config);
    setValidation(isValid(newConfig));
    onChange(newConfig);
  };

  const handleSubmit: React.FormEventHandler = (e) => {
    e.preventDefault();
    setSubmitCount(submitCount + 1);
    if (validation[0]) {
      setIsSending(true);
      onSubmit(config).finally(() => setIsSending(false));
    }
  };

  const nameErrors = validation?.[1]?.name ?? [];

  return (
    <form onSubmit={handleSubmit} className="widget-initiator-form" noValidate>
      <Stack spacing={2}>
        <TextInput
          label="Nom"
          onChange={handleNameChange}
          errors={
            submitCount > 0
              ? { tag: 'Submited', errors: nameErrors }
              : { tag: 'Not submitted' }
          }
          name={'Nom'}
          value={getName(config) ?? ''}
          required
        />
        <TextInput
          label="Texte à afficher"
          onChange={handleDefaultValueChange}
          name={'Nom'}
          multiline={true}
          defaultValue={getTextValue(config) ?? ''}
        />
        <Box
          sx={{ m: 1, position: 'relative' }}
          display="flex"
          justifyContent="center"
          alignItems="center"
        >
          <Button
            variant="outlined"
            loadingPosition="end"
            endIcon={<SaveIcon />}
            disabled={isSending}
            loading={isSending}
            type="submit"
          >
            Enregistrer
          </Button>
        </Box>
      </Stack>
    </form>
  );
}

export default ResourceWidgetInitiatorForm;
